// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import type { AlarmContextSeed } from '../types';

/** "asset · id" label for an alarm context seed, as shown on its chip. */
export function formatContextLabel(seed: AlarmContextSeed): string {
  return [seed.asset, seed.id].filter(Boolean).join(' · ');
}
